import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import nbrApi from '../../../services/nbrApi';
import { useNavigate, useParams } from 'react-router-dom';

// Validation schema
const validationSchema = Yup.object().shape({
    roomItemType: Yup.string().required('Room Item Type is required'),
    roomItem: Yup.string().required('Room Item is required'),
    taskType: Yup.string().required('Task Type is required'),
    task: Yup.string().required('Task is required')
});

let property = JSON.parse(localStorage.getItem('selectedProperty')) || null

const RoomITemMappingForm = (props) => {
    const { id } = useParams()
    const navigate = useNavigate()
    // State declarations
    const [roomItemTypes, setRoomItemTypes] = useState([]);
    const [roomItems, setRoomItems] = useState([]);
    const [taskTypes, setTaskTypes] = useState([]);
    const [tasks, setTasks] = useState([]);
    // const navigate = useNavigate()

    // Formik form handling
    const formik = useFormik({
        initialValues: {
            roomItemType: '',
            roomItem: '',
            taskType: '',
            task: ''
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            // console.log(values)
            props.handleAction(values)
        },
    });

    // Fetch room item types by property ID and room type ID
    const getRoomItemTypes = async () => {
        if (!formik.values.roomItemType) {
            setRoomItemTypes([]);
        }
        try {
            const response = await nbrApi.get(`/getroomitemtypesbyp?properties_id=${formik.values.property}`);

            const data = response.data;
            setRoomItemTypes(data?.map(e => ({
                ...e,
                value: e?.rity_id,
                label: e?.type_name
            })));
            if (!formik.values.taskType) {
                formik.setFieldValue("roomItemType", ''); // Resetting here
            }

        } catch (error) {
            console.error('Error fetching data:', error.message);
        }
    };

    // Fetch task types by property ID
    const getTaskTypes = async () => {
        if (!formik.values.taskType) {
            setTaskTypes([]);
        }
        try {
            const response = await nbrApi.get(`/gettasksubtypesbyp?properties_id=${formik.values.property}`);

            const data = response.data;
            setTaskTypes(data?.map(e => ({
                ...e,
                value: e?.tt_id,
                label: e?.task_subtype_name
            })));
            if (!formik.values.taskType) {
                formik.setFieldValue("taskType", ''); // Resetting here
            }

        } catch (error) {
            console.error('Error fetching data:', error.message);
        }
    };

    // Fetch room items by property ID, room type ID, and room item type ID
    const getRoomItems = async () => {
        if (formik.values.property && formik.values.roomItemType) {
            if (formik.values.roomItem !== '') {
                setRoomItems([]);
            }
            try {
                const response = await nbrApi.get(`/getroomitemsbyrity?properties_id=${formik.values.property}&rity_id=${formik.values.roomItemType}`);

                const data = response.data;
                setRoomItems(data?.map(e => ({
                    ...e,
                    value: e?.ri_id,
                    label: e?.item_name
                })));
                if (!formik.values.roomItem) {
                    formik.setFieldValue("roomItem", ''); // Resetting here
                }
            } catch (error) {
                console.error('Error fetching data:', error.message);
            }
        }
    };


    // Fetch tasks by property ID, room type ID, room item type ID, and task type ID
    const getTasksList = async () => {
        if (formik.values.property && formik.values.taskType) {
            if (!formik.values.task) {
                setTasks([]);
            }
            try {
                const response = await nbrApi.get(`/gettasksbypbytt?properties_id=${formik.values.property}&tt_id=${formik.values.taskType}`);

                const data = response.data;
                setTasks(data?.map(e => ({
                    ...e,
                    value: e?.rit_id,
                    label: e?.item_task_name
                })));
                if (!formik.values.task) {
                    formik.setFieldValue("task", ''); // Resetting here
                }

            } catch (error) {
                console.error('Error fetching data:', error.message);
            }
        }
    };


    useEffect(() => {
        if (!props?.data) {
            if (property?.value) {
                formik.setFieldValue('property', property.value)
            }
        }
        if (formik.values.property) {
            // Fetch initial data
            getRoomItemTypes();
            getTaskTypes();
        }
    }, [formik.values.property]);

    useEffect(() => {
        getRoomItems();
    }, [formik.values.property, formik.values.roomItemType]);

    useEffect(() => {
        // Fetch tasks when taskType changes
        getTasksList();
    }, [formik.values.property, formik.values.taskType]);


    // if have props data for edit
    useEffect(() => {
        if (props?.data && (!formik.values.task && !formik.values.taskType && !formik.values.roomItem && !formik.values.roomItemType)) {
            const { selectedData, task_list, task_type_list, room_item_list, room_item_type_list } = props?.data

            setTaskTypes(task_type_list?.map(e => {
                return {
                    ...e,
                    value: e?.pk_id,
                    label: e?.task_subtype_name
                }
            }))

            setRoomItemTypes(room_item_type_list?.map(e => {
                return {
                    ...e,
                    value: e?.pk_id,
                    label: e?.type_name
                }
            }))

            setRoomItems(room_item_list?.map(e => {
                return {
                    ...e,
                    value: e?.pk_id,
                    label: e?.item_name
                }
            }))

            setTasks(task_list?.map(e => {
                return {
                    ...e,
                    value: e?.pk_id,
                    label: e?.item_task_name
                }
            }))

            formik.setFieldValue('property', selectedData?.property)
            formik.setFieldValue('task', selectedData?.selectedOptionItemTasks)
            formik.setFieldValue('taskType', selectedData?.selectedOptionTaskTypes)
            formik.setFieldValue('roomItem', selectedData?.selectedOptionRoomItems)
            formik.setFieldValue('roomItemType', selectedData?.selectedOptionRoomItemTypes)

        }
    }, [props.data])

    useEffect(() => {
        localStorage.setItem('room-tem-data', JSON.stringify(formik.values))
    },[formik.values])
    // Render
    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="row">
                <div className="form-group mb-3">
                    <label className="m-1 text-black" htmlFor="roomItemType">Room Item Type:</label>
                    <Select
                        className="form-control p-0"
                        options={roomItemTypes}
                        id="roomItemType"
                        onChange={(selectedOption) => formik.setFieldValue("roomItemType", selectedOption.value)}
                        value={roomItemTypes?.find(option => option.value === formik.values.roomItemType) || {}}
                    />
                    {formik.errors.roomItemType && formik.touched.roomItemType && (
                        <div className="text-danger mt-3">{formik.errors.roomItemType}</div>
                    )}
                </div>
                <div className="form-group mb-3">
                    <label className="m-1 text-black" htmlFor="roomItem">Room Item:</label>
                    <div className='d-flex'>
                        <Select
                            className="form-control p-0"
                            options={roomItems}
                            id="roomItem"
                            onChange={(selectedOption) => formik.setFieldValue("roomItem", selectedOption.value)}
                            value={roomItems?.find(option => option.value === formik.values.roomItem) || {}}
                        />
                        {id &&
                            <button type='button' onClick={() => navigate(roomItems?.find(option => option.value === formik.values.roomItem) ? '/room-item/edit/' + formik.values.roomItem : '/room-item/create')}
                                className='mt-1 btn btn-primary'><i className='py-0 fa fa-edit' /></button>
                        }
                    </div>

                    {formik.errors.roomItem && formik.touched.roomItem && (
                        <div className="text-danger mt-3">{formik.errors.roomItem}</div>
                    )}
                </div>
                <div className="form-group mb-3">
                    <label className="m-1 text-black" htmlFor="taskType">Task Type:</label>
                    <Select
                        className="form-control p-0"
                        options={taskTypes}
                        id="taskType"
                        onChange={(selectedOption) => formik.setFieldValue("taskType", selectedOption.value)}
                        value={taskTypes?.find(option => option.value === formik.values.taskType) || {}}
                    />
                    {formik.errors.taskType && formik.touched.taskType && (
                        <div className="text-danger mt-3">{formik.errors.taskType}</div>
                    )}
                </div>
                <div className="form-group mb-3">
                    <label className="m-1 text-black" htmlFor="task">Task:</label>
                    <div className='d-flex'>
                        <Select
                            className="form-control p-0"
                            options={tasks}
                            id="task"
                            onChange={(selectedOption) => formik.setFieldValue("task", selectedOption.value)}
                            value={tasks?.find(option => option.value === formik.values.task) || {}}
                        />
                        {id &&
                            <button type='button'
                            onClick={() => navigate(tasks?.find(option => option.value === formik.values.task) ? '/room-task/edit/' + formik.values.task : '/room-task/create')}
                            className='mt-1 btn btn-primary'><i className='py-0 fa fa-edit' /></button>
                        }
                    </div>
                    {formik.errors.task && formik.touched.task && (
                        <div className="text-danger mt-3">{formik.errors.task}</div>
                    )}
                </div>
            </div>
            <button type="submit" className="btn btn-primary">Submit</button>
        </form>
    );
};

export default RoomITemMappingForm;
